import DialogTitle, { DialogTitleProps } from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import React, { FunctionComponent } from "react";
import IconButton from "../button/IconButton";
import OverflowText from "../text/OverflowText";

export interface _DialogTitleProps extends Omit<DialogTitleProps, "children"> {
	/** event handler called by either the confirm or cancel button */
	onClose?: () => void;

	/** localization resource for dialog title */
	res?: string;

	/** parameters for localization resource for dialog title */
	resParams?: Array<number | string>;

	/** dialog title (if not specifying localization resource) */
	text?: string;
}

export const _DialogTitle: FunctionComponent<_DialogTitleProps> = (props) => {
	const {
		onClose,
		res,
		resParams,
		text,
		...otherProps
	} = props;


	return (
		// NOTE: override DialogTitle default of using h2 component (which introduces a slight top margin due to other C8 styling)
		<DialogTitle
			component="div"
			{...otherProps}
		>
			<OverflowText
				bold
				grow
				lineHeight={16}
				res={res}
				resParams={resParams}
				size={14}
				text={text}
			/>
			{onClose && (
				<IconButton
					aria-label="close"
					onClick={onClose}
					res="Cancel"
					size="large"
					sx={{ marginLeft: 4 }}
				>
					<CloseIcon />
				</IconButton>
			)}
		</DialogTitle>
	);
};

export default _DialogTitle;